import { SearchOutlined } from '@ant-design/icons';
import { DatePicker, Input, Table } from 'antd';
import { COLUMN_MEDIUM, PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import React from 'react';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { boolToText, formatDate } from 'utils';
import { renderWithTooltip } from 'utils/table';

function HandbookCalendarTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  onRowClick,
  onChange,
}) {
  const columns = [
    {
      title: 'Дата',
      dataIndex: 'date',
      key: 'date',
      render: (value) => formatDate(value),
      filterDropdown: ({ setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <DatePicker
              locale="ru-RU"
              onChange={(_, dateStr) => {
                setSelectedKeys(dateStr ? [dateStr] : []);
                confirm({ closeDropdown: false });
              }}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.date === value;
      },
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      render: (value) => renderWithTooltip(value),
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по наименованию"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.name.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
      render: (value) => renderWithTooltip(value),
    },
    {
      title: 'Рабочий день 5',
      dataIndex: 'work_day_5',
      key: 'work_day_5',
      render: (value) => boolToText(value),
    },
    {
      title: 'Рабочий день 6',
      dataIndex: 'work_day_6',
      key: 'work_day_6',
      render: (value) => boolToText(value),
    },
    {
      title: 'Выходной',
      dataIndex: 'holiday',
      key: 'holiday',
      render: (value) => boolToText(value),
    },
    {
      title: 'Государственный праздник',
      dataIndex: 'public_holiday',
      key: 'public_holiday',
      render: (value) => boolToText(value),
    },
    {
      title: 'Пометка',
      dataIndex: 'remark',
      key: 'remark',
      render: (value) => boolToText(value),
    },
    {
      title: 'Отображать в мобилке',
      dataIndex: 'need_to_mobile',
      key: 'need_to_mobile',
      render: (value) => boolToText(value),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      pagination={{
        total: totalRows,
        current,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      scroll={{ x: 1200, y: SCROLL_Y }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { HandbookCalendarTable };
